export default __webpack_public_path__ + "static/media/laptop.a7cc894a.jpg";